// extracted by mini-css-extract-plugin
module.exports = {"footer":"index--footer--1R00m","footer__link":"index--footer__link--3WYcS"};